import { Injectable } from "@angular/core";
import { Router } from "@angular/router";
import { PageState } from "@core/models/common.interface";

@Injectable({
  providedIn: "root",
})
export class PageService {
  constructor(private router: Router) {}

  getPageState(): PageState {
    const currentPage = this.router.url;

    switch (currentPage) {
      case "/landing":
        return PageState.dashboard;

      case "/auth/login":
        return PageState.login;

      default:
        return PageState.other;
    }
  }
}
